import libConstants from '../../constants';
import computeTagName from '../../../../../utils/computeTagName';
import computeClassName from '../../../../../utils/computeClassName';
import {getValidProp} from '../../../../../utils/cleanValidateStringPropValue';


const constants = Object.freeze({
    COMPONENT_NAME: 'CCBadgeLight',
    SIZE_LARGE: 'large',
    SIZE_MEDIUM: 'medium',
    SIZE_SMALL: 'small',
    SIZES: ['small', 'medium', 'large'],
    SIZE_DEFAULT: 'medium',

    COLOR_BLUE: 'blue',
    COLOR_GRAY: 'gray',
    COLOR_STROKED: 'stroked',
    COLOR_GREEN: 'green',
    COLOR_ORANGE: 'orange',
    COLOR_RED: 'red',
    COLORS: ['blue', 'gray', 'stroked', 'green', 'orange', 'red'],

    COLOR_DEFAULT: 'gray',

    TAG_DEFAULT: 'span',

    CLASSNAME_BASE: 'text-cc-gray-dark rounded inline-flex flex-row items-center',
    CLASSNAME_SIZES: {
      small: 'px-2 py-1 text-cc-body-small',
      medium: 'px-2 py-1.5 text-cc-body-medium',
      large: 'px-2 py-2 text-cc-body-large'
    },
    CLASSNAME_COLORS: {
      blue: 'bg-cc-accent-light',
      gray: 'bg-cc-gray-light',
      stroked: 'bg-transparent ring-1 ring-inset ring-cc-gray-40',
      green: 'bg-cc-success-light',
      orange: 'bg-cc-warning-light',
      red: 'bg-cc-alert-light'
    }
});

export const propsDefaults = Object.freeze({
  size: constants.SIZE_DEFAULT,
  color: constants.COLOR_DEFAULT,
  validateProps: true,
  tag: constants.TAG_DEFAULT,
  className: ''
});

export function getValidSize(propsSize, componentName = constants.COMPONENT_NAME) {
  return getValidProp(propsSize, 'size', constants.SIZE_DEFAULT, constants.SIZES, componentName, libConstants.LIB_DEBUG_LOGGER);
}

export function getValidColor(propsColor, componentName = constants.COMPONENT_NAME) {
  return getValidProp(propsColor, 'color', constants.COLOR_DEFAULT, constants.COLORS, componentName, libConstants.LIB_DEBUG_LOGGER);
}

function getComputedClassName(propsClassName, validBadgeSize, validBadgeColor) {
  return `${computeClassName(propsClassName, constants.CLASSNAME_BASE)} ${constants.CLASSNAME_SIZES[validBadgeSize]} ${constants.CLASSNAME_COLORS[validBadgeColor]}`;
}


export default function CCBadgeLight(
  {
    size = propsDefaults.size,
    color = propsDefaults.color,
    tag = propsDefaults.tag,
    className = propsDefaults.className,
    validateProps = propsDefaults.validateProps,
    children
  }
) {
  const validSize = validateProps ? getValidSize(size) : size;
  const validColor = validateProps ? getValidColor(color) : color;
  const ComputedTagName = computeTagName(tag, constants.TAG_DEFAULT);
  const computedClassName = getComputedClassName(className, validSize, validColor);
  return (
    <ComputedTagName className={computedClassName}>{children}</ComputedTagName>
  );
}
